export const firebaseConfig = {
  apiKey: "AIzaSyACspkDKFTSmg0fiwhZd8It6yHzK8SPoec",
  authDomain: "getactyv.firebaseapp.com",
  projectId: "getactyv",
  storageBucket: "getactyv.appspot.com",
  messagingSenderId: "490641590426",
  appId: "1:490641590426:web:e675e720f95e165b923723",
  measurementId: "G-4S07J08TD7"
};